'use client';

// Export the full enquiry book as a CSV that opens cleanly in Excel
// (UTF-8 BOM for ₹/names). Pilot operator request — matches her old
// monthly sales sheet workflow.
import { formatDate, formatDateTime, normalizePhone } from "./parts";

const esc = (v) => {
  if (v == null) return "";
  const s = String(v);
  return /[",\n]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s;
};

export const exportEnquiriesCsv = (enquiries, costume, stages = costume.stages) => {
  const cap = (s) => s.charAt(0).toUpperCase() + s.slice(1);
  const stageLabel = (k) => stages.find((s) => s.key === k)?.label || k;
  const headers = [
    "Created", "Name", "Phone", "Email", "Company", "Source", "Type",
    cap(costume.vocab.units), cap(costume.vocab.location), "Stage", "Next follow-up", "Budget (INR/mo)",
    "Deal value (INR/mo)", "Closed by", "Lost reason", "Assigned to",
    "Notes", "Last remark",
  ];
  const rows = enquiries.map((e) => {
    const lastRemark = (e.remarks || []).filter((r) => !r.system).slice(-1)[0];
    return [
      formatDate(e.created_at),
      e.name,
      normalizePhone(e.phone),
      e.email || "",
      e.company || "",
      e.source,
      e.enquiry_type || "",
      e.seat_count ?? "",
      e.location_name || "",
      stageLabel(e.stage),
      e.next_followup_date ? formatDate(e.next_followup_date) : "",
      e.budget ?? "",
      e.deal_value ?? "",
      e.closed_by || "",
      e.lost_reason || "",
      e.assigned_to || "",
      e.notes || "",
      lastRemark ? `${formatDateTime(lastRemark.at)} — ${lastRemark.text}` : "",
    ].map(esc).join(",");
  });
  const csv = "\ufeff" + headers.join(",") + "\n" + rows.join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `enquiries_${new Date().toISOString().slice(0, 10)}.csv`;
  a.click();
  URL.revokeObjectURL(url);
};
